<template>
  <div class="CardConfig-page" ref="container">
		<div class="info-content">
			<div class="info-box" v-for="(item, index) in priceConfig" :key="index" v-if="priceConfig.length > 0">
				<div class="info-box-content">
					<div class="info-box-label" @click="pickWeek(index)">
						<div class="label-name">日期</div>
						<div class="label-value">
							<input type="input" v-model="item.dayValue" placeholder="请选择" readonly/>
							<div class="error-message" v-if="error[index] && error[index].dayValue">{{error[index].dayValue}}</div>
						</div>
						<div class="iconfont icon-xiangyou"></div>
					</div>
					<div class="info-box-label" @click="pickTime(index)">
						<div class="label-name">时间</div>
						<div class="label-value">
							<input type="input" v-model="item.timeValue" placeholder="请选择" readonly/>
							<div class="error-message" v-if="error[index] && error[index].timeValue">{{error[index].timeValue}}</div>
						</div>
						<div class="iconfont icon-xiangyou"></div>
					</div>
					<div class="info-box-label">
						<div class="label-name">洗澡+烘干(大型)</div>
						<div class="label-value">
							<input type="input" v-model="item.allPrice" placeholder="请填写价格"/>
							<div class="error-message" v-if="error[index] && error[index].allPrice">{{error[index].allPrice}}</div>
						</div>
					</div>
					<div class="info-box-label">
						<div class="label-name">仅烘干(大型)</div>
						<div class="label-value">
							<input type="input" v-model="item.onlyPrice" placeholder="请填写价格"/>
							<div class="error-message" v-if="error[index] && error[index].onlyPrice">{{error[index].onlyPrice}}</div>
						</div>
					</div>
					<div class="info-box-label">
						<div class="label-name">洗澡+烘干(小型)</div>
						<div class="label-value">
							<input type="input" v-model="item.mini_allPrice" placeholder="请填写价格"/>
							<div class="error-message" v-if="error[index] && error[index].mini_allPrice">{{error[index].mini_allPrice}}</div>
						</div>
					</div>
					<div class="info-box-label">
						<div class="label-name">仅烘干(小型)</div>
						<div class="label-value">
							<input type="input" v-model="item.mini_onlyPrice" placeholder="请填写价格"/>
							<div class="error-message" v-if="error[index] && error[index].mini_onlyPrice">{{error[index].mini_onlyPrice}}</div>
						</div>
					</div>
					<div class="info-box-label">
						<div class="label-name">烘干(元/分钟)</div>
						<div class="label-value">
							<input type="input" v-model="item.dry_unit_price" placeholder="请填写价格"/>
							<div class="error-message" v-if="error[index] && error[index].dry_unit_price">{{error[index].dry_unit_price}}</div>
						</div>
					</div>
					<div class="info-box-label">
						<div class="label-name">洗护(元/分钟)</div>
						<div class="label-value">
							<input type="input" v-model="item.wash_unit_price" placeholder="请填写价格"/>
							<div class="error-message" v-if="error[index] && error[index].wash_unit_price">{{error[index].wash_unit_price}}</div>
						</div>
					</div>
				</div>
				<div class="info-box-bottom">
						<div class="remove"><span @click="removePrice(index)">删除规则</span></div>
				</div>
			</div>
			
			<div class="noCart" v-if="priceConfig.length == 0">
			  <div class="pictrue"><img src="@assets/images/nodata.png" /></div>
			</div>
		</div>
		
		<div class="btnView">
			<div class="btn btn-add" @click="addPrice()">添加</div>
			<div class="btn btn-save" v-if="priceConfig.length > 0" @click="savePrice()">保存</div>
		</div>
		
		<Popup v-model="showWeekPicker" position="bottom">
			<Picker
				show-toolbar
				:columns="columns"
				:default-index="weekIndex"
				@confirm="weekPickerConfirm"
				@cancel="weekPickerCancel"
			></Picker>
		</Popup>
		
		<Popup v-model="showTimePicker" position="bottom">
			<div class="tool-view">
				<div class="tool-btn cancel" @click="timeCancel">取消</div>
				<div class="tool-btn confirm" @click="timeConfirm">确认</div>
			</div>
			<div class="time-range-view">
				<div class="time" :class="setName =='startTime' ? 'setting' : ''" @click="setTime('startTime')">{{startTime}}</div>
				<div> ~ </div>
				<div class="time" :class="setName =='endTime' ? 'setting' : ''" @click="setTime('endTime')">{{endTime}}</div>
			</div>
			<Picker
				:show-toolbar="false"
				:columns="timeColumns"
				@change="timeChange"
				ref="picker"
			></Picker>
		</Popup>
	</div>
</template>
<script>
import PetApi from "../../api/petAdmin";
import { DatetimePicker, Popup, Picker, Toast} from 'vant';
export default {
  name: "PetAdminPriceConfig",
  components: {
		DatetimePicker,
		Popup,
		Picker,
		Toast
	},
  props: {},
  data: function() {
    return {
			currentTime : "00:00",
			setName:'startTime',
			startTime : "00:00",
			endTime: "00:00",
			pickerTitle : '开始时间',
			showTimePicker : false,
			index : 0,
			deviceSn: this.$route.params.deviceSn,
			
			weekIndex : 0,
			showWeekPicker : false,
			columns : ['每天','周一','周二','周三','周四','周五','周六','周日'],
			
			timeColumns: [],
			timeIndex : [1,2,3],
			
			error : [],
			priceConfig : [],
			priceRuleTemp : {
				id : 0,
				timerange: '',
				dayrange: '',
				onlyPrice: '',
				allPrice: '',
				mini_onlyPrice: '',
				mini_allPrice: '',
				dry_unit_price: '',
				wash_unit_price: '',
				dayValue : '',
				timeValue : '',
				startTime : '00:00:00',
				endTime : '00:00:00',
			},
    }
  },
  watch: {
    "$route.params": function(newVal) {
      var that = this;
      if (newVal != undefined) {
    		that.deviceSn = newVal.deviceSn;
    		that.getInfo()
      }
    }
  },
  mounted: function() {
		this.initColumns();
		this.getInfo();
  },
  computed: {
	},
  methods: {
		setTimeColumnsDefault(times) {
			const initialTime = times.split(':')
			console.log(initialTime)
			if(initialTime.length === 3) {
				this.$nextTick(() => {
					this.$refs.picker && this.$refs.picker.setIndexes([Number(initialTime[0]), Number(initialTime[1]), Number(initialTime[2])])
				})
			}
		},
		initColumns() {
			const list = []
			const Hours = []
			const Minutes = []
			const Seconds = []
			for (let i = 0; i<=23; i++) {
				Hours.push(String(i).padStart(2, '0'))
			}
			for (let i = 0; i<=59; i++) {
				Minutes.push(String(i).padStart(2, '0'))
				Seconds.push(String(i).padStart(2, '0'))
			}
			list.push({
				values: Hours,
				defaultIndex: 0
			})
			list.push({
				values: Minutes,
				defaultIndex: 0
			})
			list.push({
				values: Seconds,
				defaultIndex: 0
			})
			this.timeColumns = list
		},
		isPrice(value) {
			if (/(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/.test(value)) return true;
			return false;
		},
		savePrice() {
			let that = this;
			let errors = [];
			this.priceConfig.forEach((item,index) => {
				let error = {};
				if (!item.dayValue)  error.dayValue = '请选择日期';
				if (!item.timeValue) error.timeValue = '请选择时间';
				if (!this.isPrice(item.onlyPrice) || item.onlyPrice < 2.5) error.onlyPrice = '价格需大于或等于2.5';
				if (!this.isPrice(item.allPrice) || item.allPrice < 2.5) error.allPrice = '价格需大于或等于2.5';
				if (!this.isPrice(item.mini_onlyPrice) || item.mini_onlyPrice < 2.5) error.mini_onlyPrice = '价格需大于或等于2.5';
				if (!this.isPrice(item.mini_allPrice) || item.mini_allPrice < 2.5) error.mini_allPrice = '价格需大于或等于2.5';
				if (!this.isPrice(item.dry_unit_price) || item.dry_unit_price < 0.25) error.dry_unit_price = '价格需大于或等于0.25';
				if (!this.isPrice(item.wash_unit_price) || item.wash_unit_price < 0.3) error.wash_unit_price = '价格需大于或等于0.3';
				if (Object.keys(error).length !== 0) errors[index] = error
			})
			
			if (errors.length > 0) return this.error = errors;
			
			PetApi.petPriceSave({price : that.priceConfig, deviceSn : that.deviceSn}).then(
			  res => {
					that.$dialog.message(res.msg);
					that.error = [];
			  },
			  error => {
			    that.$dialog.message(error.msg);
					that.error = [];
			  }
			);
		},
		addPrice() {
			this.priceConfig.push({ ...this.priceRuleTemp });
		},
		removePrice(index) {
			this.priceConfig.splice(index,1);
		},
		
		
		
		pickWeek(index) {
			this.index = index;
			this.weekIndex = this.priceConfig[this.index].dayrange;
			this.showWeekPicker = true;
		},
		weekPickerConfirm(value, index) {
			this.priceConfig[this.index].dayrange = index;
			this.priceConfig[this.index].dayValue = value;
			this.showWeekPicker = false;
		},
		weekPickerCancel() {
			this.showWeekPicker = false;
		},
		
		
		timeCancel() {
			this.showTimePicker = false;
		},
		compareTime() {
			var date1 = new Date(`2000-01-01T${this.startTime}`);
			var date2 = new Date(`2000-01-01T${this.endTime}`);
			if (date2 > date1) return true;
			else return false;
		},
		timeConfirm() {
			if (!this.compareTime()) return Toast.fail('结束时间需要大于开始时间');
			this.priceConfig[this.index].startTime = this.startTime;
			this.priceConfig[this.index].endTime = this.endTime;
			this.priceConfig[this.index].timeValue = this.startTime + '~' + this.endTime;
			this.priceConfig[this.index].timerange = [this.startTime, this.endTime];
			this.showTimePicker = false;
		},
		setTime(timeName) {
			this.setName = timeName;
			this.currentTime = this[timeName];
			this.setTimeColumnsDefault(this.currentTime);
    },
		timeChange(obj,index) {
			this.currentTime = index.join(":");
			this[this.setName] = this.currentTime
		},
		pickTime(index) {
			this.index = index;
			this.startTime = this.priceConfig[this.index].startTime;
			this.endTime = this.priceConfig[this.index].endTime;
			this.setName = 'startTime';
			this.currentTime = this.startTime
			this.setTimeColumnsDefault(this.currentTime);
			this.showTimePicker = true;
		},
		getInfo() {
			let that = this;
			PetApi.petPriceGet(that.deviceSn).then(
			  res => {
					that.priceConfig = res.data;
			  },
			  error => {
			    that.$dialog.message(error.msg);
			  }
			);
		}
  }
};
</script>
<style lang="scss">
body {background: #F9F9F9 !important;}
.CardConfig-page {
	.info-content {
		padding: 0 0.32rem 3rem;
		.info-box {
			background: #FFFFFF;
			border-radius: .20rem;
			margin-top: 0.48rem;
			position: relative;
	
			.info-box-content {
				padding: 0 0.3rem;
				
				.info-box-label {
					display: flex;
					justify-content: space-between;
					height: 1rem;
					align-items: center;
					
					&:not(:last-child) {
						border-bottom: 0.02rem solid #E8E8E8;
					}
					
					
					.label-name {
						font-weight: 400;
						font-size: .28rem;
						color: #000000;
						width: 2.1rem;
					}
					.label-value {
						font-weight: 400;
						font-size: .28rem;
						color: #999999;
						text-align: right;
						flex: 1;
						
						input {
							text-align: right;
						}
						
						.error-message {
							color: #ee0a24;
							font-size: 0.24rem;
						}
						
					}
					
					.iconfont {
						font-weight: 600;
						font-size: 0.28rem;
						margin-left: 0.12rem;
						color: #888888;;
					}
				}
			}
		
			.info-box-bottom {
				text-align: center;
				font-weight: bold;
				font-size: 0.28rem;
				color: #F5A100;
				border-top: 0.02rem solid #E8E8E8;
				padding: 0 0.3rem;
				
				.remove {
					padding: 0.3rem 0;
					span {
						padding: 0.1rem;
					}
				}
			}
		}
	}
	
	.btnView {
		width: 100%;
		position: fixed;
		bottom : 0rem;
		padding: 0.4rem 0.32rem 0;
		display: flex;
		justify-content: center;
		height: 2rem;
		background: #f9f9f9;
		.btn {
			height: 1rem;
			line-height: 1rem;
			border-radius: .50rem;
			text-align: center;
			font-weight: 400;
			font-size: .34rem;
			
			&.btn-add {
				border: 0.02rem solid #F5A100;
				color : #F5A100;
				width: 50%;
				margin-right: 0.2rem;
			}
			
			&.btn-save {
				background: #F5A100;
				color : #fff;
				flex : 1;
			}
		}
	}
}

.time-range-view {
	display: flex;
	justify-content: space-evenly;
	font-size: 0.32rem;
	font-weight: 500;
	align-items: center;
	.time {
		height: 1rem;
		line-height: 1rem;
		width: 2rem;
		text-align: center;
		color: #9E9E9E;
		
		&.setting {
			font-weight: bold;
			color: #000;
		}
	}
}
.tool-view {
	display: flex;
	justify-content: space-between;
	height: 0.88rem;
	align-items: center;
	.tool-btn {
		padding: 0 0.32rem;
		font-size: 0.28rem;
		line-height: 0.88rem;
		
		&.cancel {color: #969799;}
		&.confirm {color: #576b95;}
	}
}

.noCart {
	margin-top: 2rem;
	padding-top: 0.1rem;
}

.noCart .pictrue {
	width: 4rem;
	height: 3rem;
	margin: 0.7rem auto 0.5rem auto;
}

.noCart .pictrue img {
	width: 100%;
	height: 100%;
}

</style>
